import { Priority } from '@/models/appointment/Appointment.ts';
import { TaskUrgency } from '@/models/doc-cirrus/DCTask.ts';

export const urgency_priority_map: Record<TaskUrgency, Exclude<Priority, Priority.NONE | Priority.IMPORTANT>> = {
    1: Priority.LOW,
    2: Priority.NORMAL,
    3: Priority.VERYIMPORTANT,
    4: Priority.CRITICAL,
};
